import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57e7b81d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-2xl w-full text-center mt-10" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Vue.js GPT API Sample:")
], -1))
const _hoisted_3 = { class: "main container mx-auto mt-10" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, [
  /*#__PURE__*/_createTextVNode(" To get an API KEY you need to register new OPEN API account and then visit "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://platform.openai.com/account/api-keys",
    target: "_blank"
  }, " https://platform.openai.com/account/api-keys ")
], -1))
const _hoisted_5 = { class: "description mt-4" }
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_InputTextarea = _resolveComponent("InputTextarea")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_InputText, {
        value: _ctx.apiKey,
        "onUpdate:value": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.apiKey) = $event)),
          _cache[1] || (_cache[1] = (val) => _ctx.api.setApiKey(val))
        ],
        label: 'API Key:',
        class: "w-1/2 mt-4",
        placeholder: "Paste a key here"
      }, null, 8, ["value"]),
      _createVNode(_component_Tabs, {
        value: _ctx.tab,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tab) = $event)),
        tabs: _ctx.tabs,
        class: "mt-8"
      }, null, 8, ["value", "tabs"]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          target: "_blank",
          href: _ctx.tab === 'code' ? 'https://platform.openai.com/docs/guides/code' : 'https://platform.openai.com/docs/guides/completion'
        }, "API Guide", 8, _hoisted_6)
      ]),
      _createVNode(_component_InputTextarea, {
        value: _ctx.promt,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.promt) = $event)),
        label: 'Promt:',
        class: "w-1/2 mt-8",
        rows: 10
      }, null, 8, ["value"]),
      _createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.run && _ctx.run(...args))),
        class: "mt-2 bg-gray-300 px-2 py-1"
      }, _toDisplayString(_ctx.isLoading ? 'Loading...' : 'Run'), 1),
      _createVNode(_component_InputTextarea, {
        value: _ctx.result,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.result) = $event)),
        label: 'Result:',
        disabled: "",
        class: "mt-8 w-1/2",
        rows: 10
      }, null, 8, ["value"])
    ])
  ]))
}